import { render, staticRenderFns } from "./MllwLoginView.vue?vue&type=template&id=f72fddd4"
import script from "./MllwLoginView.ts?vue&type=script&lang=ts&external"
export * from "./MllwLoginView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports